/** Local form state contains only properties the user actually changed. */
export interface PropertyDraft {
  changes: Record<string, unknown>;
  baseline: Record<string, unknown>;
}
const same = (left: unknown, right: unknown) => JSON.stringify(left) === JSON.stringify(right);
export function updatePropertyDraft(previous: PropertyDraft | undefined, current: object, changes: Record<string, unknown>): PropertyDraft {
  const draft: PropertyDraft = { changes: {...previous?.changes}, baseline: {...previous?.baseline} };
  for (const [key,value] of Object.entries(changes)) {
    if (!Object.hasOwn(draft.baseline,key)) draft.baseline[key] = structuredClone((current as Record<string,unknown>)[key]);
    if (same(value,draft.baseline[key])) { delete draft.changes[key]; delete draft.baseline[key]; }
    else draft.changes[key] = value;
  }
  return draft;
}
export function hasPropertyChanges(draft: PropertyDraft | undefined): boolean { return !!draft && Object.keys(draft.changes).length > 0; }
/** Rebased receipts update untouched inputs while preserving the local input value. */
export function propertyDraftValue<T>(current: T, draft: PropertyDraft | undefined): T { return {...current,...draft?.changes}; }
export function propertyDraftPatch(draft: PropertyDraft): { changes: Record<string, unknown>; unset?: string[] } {
  const changes:Record<string,unknown>={}, unset:string[]=[];
  for(const [key,value] of Object.entries(draft.changes)) { if(value === undefined)unset.push(key);else changes[key]=value; }
  return {changes,...(unset.length ? {unset} : {})};
}
